import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Badge, useTheme } from "@mui/material";
import Avatar from "@mui/material/Avatar";

export default function StudentAvatar(props) {
	const theme = useTheme();
	let { student, enrollment } = props;
	if (!student?.id) {
		return;
	}

	const size = props?.size || 20;
	const sx = {
		height: size,
		width: size,
		bgcolor: student.colour
	};
	const variant = props?.variant || 'circular';

	const avatar = (
		<Avatar src={student.profilePicture || '/null.png'} alt={student.name} title={student.name} sx={sx} variant={variant} />
	);

	if (enrollment) {
		let badgeSx = {};
		if( enrollment.completeness == 100 ){
			badgeSx = {'.MuiAvatar-root': {outline: '1px auto ' + theme.palette.success.main}};
		}
		else if( enrollment.completeness > 0 || enrollment.status == 'In Progress' || (enrollment.startDate > new Date().getTime() && enrollment.endDate < new Date().getTime())){
			badgeSx = {'.MuiAvatar-root': {outline: '1px dashed ' + theme.palette.info.main}};
		}
		else{
			badgeSx = {'.MuiAvatar-root': {outline: '1px solid ' + theme.palette.action.disabled}};
		}
		return (
			<Badge overlap="circular" anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} sx={badgeSx}>
				{avatar}
			</Badge>
		);
	}

	return avatar;
}
